import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { abbrNum } from '@src/shared/includes/functions';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';

/**
 * HorizontalBarChart
 *
 * @TODO Needs description.
 *
 * @param data
 * @returns {React.JSX.Element|string}
 * @constructor
 */
export function HorizontalBarChart({ data }) {
  const [labels, setLabels] = useState([]);
  const [dataset, setDataset] = useState([]);

  /**
   * @TODO Needs description.
   */
  useEffect(() => {
    if (!isEmpty(data)) {
      const theLabels = [];
      const theDataset = [];

      data?.forEach((item) => {
        if (!theLabels.includes(data?.label)) {
          theLabels.push(item?.label);
        }

        if (!theDataset.includes(data?.total)) {
          theDataset.push(item?.total);
        }
      });

      if (theLabels !== labels) {
        setLabels(theLabels);
      }

      if (theDataset !== dataset) {
        setDataset(theDataset);
      }
    }
  }, [data]);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/EntityLastModified/components/HorizontalBarChart/HorizontalBarChart.jsx">
      <Bar
        data={{
          datasets: [
            {
              backgroundColor: themeConfiguration?.theme?.colors?.info2,
              borderColor: themeConfiguration?.theme?.colors?.info1,
              borderWidth: 1,
              data: dataset,
              grouped: false,
              hoverBackgroundColor: themeConfiguration?.theme?.colors?.info1,
              hoverBorderColor: themeConfiguration?.theme?.colors?.info2,
              label: '',
            },
          ],
          labels,
        }}
        options={{
          animation: {
            duration: 0, // general animation time
          },
          hover: {
            animationDuration: 0, // duration of animations when hovering an item
          },
          indexAxis: 'y',
          plugins: {
            legend: {
              display: false,
            },
          },
          responsive: true,
          responsiveAnimationDuration: 0, // animation duration after a resize
          scales: {
            x: {
              ticks: {
                callback(value) {
                  return `${abbrNum(Number(value), 2)}`;
                },
              },
            },
          },
        }}
      />
    </ErrorHandler>
  );
}
